// extracted by mini-css-extract-plugin
module.exports = {"dataSheetWrapper":"DataSheet_dataSheetWrapper__xY8o3","circleLoader":"DataSheet_circleLoader__1xKay","cellInput":"DataSheet_cellInput__2DgAl"};